import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import "./output.css";
import Register from "./components/auth/Register";
import Dashboard from "./components/dashboard/dashboard";
import EmailVerification from "./components/auth/EmailVerification";
import Chat from "./components/chat/Chat";
import UserProfile from "./components/userProfile/UserProfile";
import User from "./components/userProfile/User";
import Notifs from "./components/userProfile/Notifs";
import AllUsers from "./components/chat/AllUsers";
import Deposit from "./components/payments/Deposit";
import Withdraw from "./components/payments/WithdrawModal";
import socketManager from "./socket";
import { useEffect } from "react";
import Login from "./components/auth/Login";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import ScrollTo from "./components/scroll/ScrollTo";
import SelectAvatar from "./components/userProfile/SelectAvatar";
import Tournaments from "./components/tournament/tournament";
import AllGames from "./components/games/AllGames";
import SelectedGame from "./components/games/SelectedGame";
import JoinLobby from "./components/games/JoinLobby";
import AllTournaments from "./components/tournament/AllTournaments";
import WatingRoom from "./components/tournament/waitingRoom/watingRoom";
import ProtectedRoute from "./components/ProtectedRoute";
import ProfileNavbar from "./components/userProfile/UserProfileNav";
import SelectedUserPage from "./components/games/SelectedUser";
import GameResult from "./components/games/GameResult";
import GameRating from "./components/games/GameRating";
import { useState } from "react";
import { SpeedInsights } from "@vercel/speed-insights/react";

// PLEASE DONT REMOVE (FOR DEVELOPMENT)
import { useContext } from "react";

// game imports
import Game from "./components/games/chess/components/game";
import { allUsers } from "./components/games/auxiliary/gamesAux";
import userProfile1 from "./assets/images/userProfile1.png";

import { RecoilRoot } from "recoil";

import Ludo from "./components/games/ludo/src/Ludo";

import Whot from "./components/games/whot/src/pages/PlayFriend/Whot";
import { Provider } from "react-redux";
import store from "./components/games/whot/src/redux/playFriendStore";

import Snooker from "./components/games/snooker/src/Snooker";
import Scrabble from "./components/games/scrabble/Scrabble";
// PLEASE DONT REMOVE (FOR DEVELOPMENT)
import { UserContext } from "./utils/contexts/UserContext";
import AccountTypeSelection from "./components/auth/AccountTypeSelection";
import SplashScreen from "./components/splashScreen";
import ActivePlayers from "./components/games/ActivePlayer";
import Notifications from "./components/userProfile/Notifications";
import TransacHistory from "./components/userProfile/TransacHistory";
import HostGame from "./celebrity/HostGame";
import CreateHostedGame from "./celebrity/CreateHostedGame";
import SetWinnings from "./celebrity/setWinnings";
import GateFee from "./celebrity/gateFee";
import TournamentCode from "./celebrity/tournamentCode";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyTournaments from "./celebrity/MyTournaments";
import Leaderboard from "./celebrity/Leaderboard";
import TournamentLobby from "./components/tournament/tournamentLobby";
import WaitingRoom from "./components/tournament/waitingRoom";
import FAQ from "./components/userProfile/FAQ";
import ContactUs from "./components/userProfile/ContactUs";
import TermsAndConditions from "./components/userProfile/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { NotificationHandler } from "./components/NotificationHandler";
import MyLobbies from "./components/games/MyLobbies";
import Referrals from "./components/userProfile/Referrals"; // <-- Add this import
import ChatWithUs from "./components/userProfile/ChatSupport"; // <-- Add this import
import AllLobbies from "./components/games/AllLobbies";
import QuickMatch from "./components/games/QuickMatch";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const navigateTo = (path) => navigate(path);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [activeChat, setActiveChat] = useState(null);
  const [activeChatMsgs, setActiveChatMsgs] = useState([]);
  const [showChatMsgs, setShowChatMsgs] = useState(false);
  const [gameResult, setGameResult] = useState(null);

  const [showOffCanvasNav, setShowOffCanvasNav] = useState(false);

  const openOffCanvasNav = () => setShowOffCanvasNav(true);
  const closeOffCanvasNav = () => setShowOffCanvasNav(false);

  // Desktop compatibility check
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const checkDesktop = () => {
      // You can adjust the width threshold as needed
      if (window.innerWidth > 760) {
        setIsDesktop(true);
      } else {
        setIsDesktop(false);
      }
    };
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => window.removeEventListener("resize", checkDesktop);
  }, []);

  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    // Only show splash if not shown in this session
    const splashShown = localStorage.getItem("splashShown");
    if (splashShown) {
      setShowSplash(false);
      return;
    }
    const timer = setTimeout(() => {
      setShowSplash(false);
      // localStorage.setItem("splashShown", "true");
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  // Check for game results when app loads
  useEffect(() => {
    const savedResult = localStorage.getItem("gameResult");
    if (savedResult) {
      try {
        const parsedResult = JSON.parse(savedResult);
        setGameResult(parsedResult);

        // For Dashboard or other components to check
        window.gameResultAvailable = true;

        // Clear result after a delay to ensure it's processed
        setTimeout(() => {
          localStorage.removeItem("gameResult");
          window.gameResultAvailable = false;
        }, 5000);
      } catch (e) {
        localStorage.removeItem("gameResult");
      }
    }
  }, []);

  const pathname = useLocation().pathname;

  const userLogout = () => {
    sessionStorage.removeItem("token");
    navigateTo("/login");
  };

  const userContext = useContext(UserContext);
  // PLEASE DONT REMOVE (FOR DEVELOPMENT)
  // COMMENT OUT IF I PUSH WITHOUT DOING SO

  useEffect(() => {
    if (!userContext || !userContext.user || !userContext.user._id) {
      return;
    }

    // Create comprehensive user data object with all possible ID fields for compatibility
    const userData = {
      userId: userContext.user._id,
      userID: userContext.user._id, // Include both formats for server compatibility
      _id: userContext.user._id, // Include MongoDB format
      username:
        userContext.user.username || userContext.user.name || "Unknown User",
      name:
        userContext.user.name || userContext.user.username || "Unknown User",
      avatar: userContext.user.avatar || null,
    };

    // console.log('Connecting socket with user data:', userData);

    // Connect using the improved socket manager
    const socket = socketManager.connect(userData);

    // We need multiple mechanisms to ensure the user stays registered as active

    // 1. Set up intervals for repeated registration and requests
    const activeRegistrationInterval = setInterval(() => {
      if (socketManager.isConnected()) {
        // Re-register as active every minute
        socket.emit("user-active", userData);
      }
    }, 60000); // Every minute

    const activeUsersRequestInterval = setInterval(() => {
      if (socketManager.isConnected()) {
        // Request updated user list every 30 seconds
        socket.emit("get_active_users");
      }
    }, 30000); // Every 30 seconds

    // 2. Set up visibility change detection to re-register when tab becomes visible
    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        socketManager.isConnected()
      ) {
        // console.log('Page became visible, re-registering as active');
        socket.emit("user-active", userData);
        setTimeout(() => {
          socket.emit("get_active_users");
        }, 1000);
      }
    };

    // Add visibility change listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // 3. Add custom event listeners on top of the core ones in socketManager
    socket.on("opponent-joined-lobby", (userID, gameName, lobbyCode) => {
      // console.log(`Opponent joined lobby: ${userID}, ${gameName}, ${lobbyCode}`);
      navigateTo(
        `/tournaments/play/${userID}/${gameName}/${1000}/${lobbyCode}`
      );
    });

    // 4. Handle active users update with retry logic
    socket.on("get_active", (arrayOfUserObjects) => {
      // console.log("Received active users:", arrayOfUserObjects);

      // If we received null or undefined, request again
      if (!arrayOfUserObjects) {
        socket.emit("get_active_users");
        return;
      }

      // If we received an empty array, implement progressive retry strategy
      if (
        Array.isArray(arrayOfUserObjects) &&
        arrayOfUserObjects.length === 0
      ) {
        // console.warn("Received empty active users array, implementing recovery strategy");

        // First: Re-register immediately
        socket.emit("user-active", userData);

        // Then: Request active users after short delay
        setTimeout(() => {
          socket.emit("get_active_users");
        }, 1000);

        // Also: Try with different parameters
        setTimeout(() => {
          // Try with explicit active user event
          socket.emit("user-active", {
            ...userData,
            timestamp: Date.now(), // Add timestamp to ensure the event is seen as new
          });
        }, 3000);
      }

      // Update UI with received users (even if empty)
      // Clear existing users
      allUsers.splice(0);

      if (Array.isArray(arrayOfUserObjects)) {
        // Add self to the list if not already included (defensive measure)
        let selfIncluded = false;

        arrayOfUserObjects.forEach((userObject) => {
          if (
            userObject &&
            (userObject.userID || userObject.userId || userObject._id)
          ) {
            // Check if this is the current user
            if (
              userObject.userID === userData.userId ||
              userObject.userId === userData.userId ||
              userObject._id === userData.userId
            ) {
              selfIncluded = true;
            }

            // Add to allUsers array
            allUsers.push({
              user_id: userObject.userID || userObject.userId || userObject._id,
              name: userObject.username || userObject.name || "User",
              wins: userObject.wins || 0,
              profile: userObject.avatar || userProfile1,
              bgClass: "bg-FD8D84",
            });
          }
        });

        // If self not included, add manually (ensures user always sees themselves)
        if (!selfIncluded) {
          allUsers.push({
            user_id: userData.userId,
            name: userData.username,
            wins: userContext.user.wins || 0,
            profile: userContext.user.avatar || userProfile1,
            bgClass: "bg-FD8D84",
          });

          // Also re-register with server as this indicates registration was lost
          socket.emit("user-active", userData);
        }
      }

      // console.log("Updated active users list:", allUsers);
    });

    // 5. Set a ping interval to detect and recover from silent disconnections
    const pingInterval = setInterval(() => {
      if (socket.connected) {
        // Use a volatile emission that doesn't get buffered if disconnected
        socket.volatile.emit("heartbeat", {
          userId: userData.userId,
          timestamp: Date.now(),
        });
      } else if (socketManager.isConnected()) {
        // Socket thinks it's connected but actual socket isn't - reconnect
        socket.connect();

        // Re-register after brief delay
        setTimeout(() => {
          socket.emit("user-active", userData);
        }, 1000);
      }
    }, 45000); // Every 45 seconds

    // 6. Initialize by requesting active users and registering
    socket.emit("user-active", userData);
    setTimeout(() => {
      socket.emit("get_active_users");
    }, 1500);

    // Clean up function
    return () => {
      // console.log("App component unmounting, cleaning up socket");
      clearInterval(activeRegistrationInterval);
      clearInterval(activeUsersRequestInterval);
      clearInterval(pingInterval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      // Remove listeners
      socket.off("get_active");
      socket.off("opponent-joined-lobby");

      // Disconnect socket
      socketManager.disconnect();
    };
  }, [userContext, navigateTo]);

  // useEffect(() => {
  //   socket.on("incoming_message", (data) => {
  //     console.log(data);
  //         })
  //   }, []);

  // const goToLogin = () => {
  //   const isVerified = sessionStorage.getItem("token")
  //   if(!isVerified){
  //     navigateTo("login")
  //   }
  // }

  const accountType = localStorage.getItem("accountType");

  if (showSplash) {
    return <SplashScreen />;
  }
  if (isDesktop) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #fff 60%, #130828 100%)",
          minHeight: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 24,
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            padding: "48px 32px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: 350,
            width: "90%",
          }}
        >
          <div style={{ fontSize: 64, marginBottom: 24, color: "#130828" }}>
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="4"
                width="20"
                height="16"
                rx="3"
                stroke="#130828"
                strokeWidth="2"
              />
              <path
                d="M8 20v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1"
                stroke="#130828"
                strokeWidth="2"
              />
            </svg>
          </div>
          <div
            style={{
              fontWeight: 700,
              fontSize: 22,
              color: "#130828",
              marginBottom: 12,
              textAlign: "center",
            }}
          >
            Not Compatible
          </div>
          <div
            style={{
              fontSize: 16,
              color: "#333",
              textAlign: "center",
              marginBottom: 8,
            }}
          >
            Skyboard Games is not compatible with desktop mode.
          </div>
          <div style={{ fontSize: 15, color: "#666", textAlign: "center" }}>
            Please use a mobile device to continue.
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {userContext?.user && <NotificationHandler />}
      <SpeedInsights />
      <ToastContainer />
      <ScrollTo condition={pathname}>
        <Routes>
          {/* ACCOUNT TYPE SELECTION ROUTE */}
          <Route
            path="/choose-account-type"
            element={<AccountTypeSelection />}
          />

          {/* AUTHENTICATION ROUTES  */}
          <Route
            path="/register"
            element={
              accountType ? (
                <Register navigateTo={navigateTo} accountType={accountType} />
              ) : (
                <AccountTypeSelection />
              )
            }
          />
         <Route path="/terms" navigateTo={navigateTo} element={<TermsAndConditions />} />

          <Route
            path="/login"
            element={
              <Login navigateTo={navigateTo} accountType={accountType} />
            }
          />
          <Route
            path="/email-verification"
            element={
              <EmailVerification
                navigateTo={navigateTo}
                type="activateAcct"
                accountType={accountType}
              />
            }
          />

          <Route
            path="/forgot-password/verify-email"
            element={
              <EmailVerification
                navigateTo={navigateTo}
                type="resetPassword"
                accountType={accountType}
              />
            }
          />

          <Route
            path="/forgot-password/reset-password"
            element={<ResetPassword accountType={accountType} />}
          />

          <Route
            path="/forgot-password"
            element={
              <ForgotPassword
                navigateTo={navigateTo}
                accountType={accountType}
              />
            }
          />

          <Route path="/select-avatar" element={<SelectAvatar />} />

          {/* GAMES */}

          <Route
            path="/games/Chess/"
            element={<Game user={userContext.user} />}
          />

          <Route
            path="/games/Ludo/"
            element={
              <RecoilRoot>
                <Ludo user={userContext.user} />
              </RecoilRoot>
            }
          />
          <Route
            path="/games/Whot/"
            element={
              <Provider store={store}>
                <Whot user={userContext.user} />
              </Provider>
            }
          />
          <Route
            path="/games/Snooker/"
            element={<Snooker user={userContext.user} />}
          />
          <Route
            path="/games/Scrabble/"
            element={<Scrabble user={userContext.user} />}
          />

          /* MAIN APP ROUTES  */

                <Route
                path="/"
                element={<Navigate to="/dashboard" replace />}
                />
                <Route
                path="/dashboard"
                element={
                  <ProtectedRoute
                  element={Dashboard}
                  navigateTo={navigateTo}
                  accountType={accountType}
                  />
                }
                />

                <Route
                path="/games"
                element={
                  <ProtectedRoute
                  element={AllGames}
                  navigateTo={navigateTo}
                  accountType={accountType}
                  />
                }
                />
                <Route
                path="/games/my-lobbies"
                element={
                  <ProtectedRoute
                  element={MyLobbies}
                  navigateTo={navigateTo}
                  accountType={accountType}
                  />
                }
                />

                <Route
                path="/games/waiting-room/:lobbyId/:lobbyCode/:gameName"
                element={
                  <ProtectedRoute element={WatingRoom} navigateTo={navigateTo} />
                }
                />

                <Route
                path="/games/join-lobby"
                element={
                  <ProtectedRoute element={JoinLobby} navigateTo={navigateTo} />
                }
                />
                <Route
                path="/games/lobbies"
                element={
                  <ProtectedRoute element={AllLobbies} navigateTo={navigateTo} />
                }
                />
                <Route
                path="/games/quick-match/:lobbyCode/:currentPlayerId/:gameName/:lobbyId/:gameId"
                element={
                  <ProtectedRoute element={QuickMatch} navigateTo={navigateTo} />
                }
                />


                <Route
                path="/games/selected-game/:gameId"
                element={
                  <ProtectedRoute element={SelectedGame} navigateTo={navigateTo} />
                }
                />

                <Route
                path="/chat"
                element={<Chat navigateTo={navigateTo} accountType={accountType} />}
                />

                <Route
                path="/all-users"
                element={
                  <ProtectedRoute
                  element={AllUsers}
                  navigateTo={navigateTo}
                  accountType={accountType}
                  />
                }
                />

                <Route
                path="/tournaments"
                element={
                  <ProtectedRoute
                  element={AllTournaments}
                  navigateTo={navigateTo}
                  />
                }
                />

                <Route
                path="/tournaments/play/:user_id/:gameId/:stakeValue/:roomID"
                element={<Tournaments navigateTo={navigateTo} />}
                />

                <Route
                path="/user-profile/*"
                element={
                  <ProtectedRoute
                  element={UserProfile}
                  navigateTo={navigateTo}
                  userLogout={userLogout}
                  />
                }
                />
                <Route path="/user-profile/user" element={<User />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/user-profile/faq" element={<FAQ />} />
                <Route path="/user-profile/terms" element={<TermsAndConditions />} />
                <Route path="/user-profile/privacy" element={<PrivacyPolicy />} />
                <Route path="/user-profile/contact" element={<ContactUs />} />
                <Route path="/notifications-settings" element={<Notifs />} />
                <Route path="/transaction-history" element={<TransacHistory />} />
                <Route
                path="/user-profile/referrals"
                element={<Referrals />}
                />
                <Route
                path="/user-profile/chat-with-us"
                element={
                  <ProtectedRoute
                  element={ChatWithUs}
                
                  />
                }
                />

                <Route
                path="/user-profile/navbar"
                element={
                  <ProfileNavbar
                  userLogout={userLogout}
                  showOffCanvasNav={showOffCanvasNav}
                  closeOffCanvasNav={closeOffCanvasNav}
                  />
                }
                />

                <Route
                path="/deposit"
                element={
                  <ProtectedRoute element={Deposit} navigateTo={navigateTo} />
                }
                />

                <Route
                path="/games/selected-player/:lobbyCode"
                element={<ActivePlayers />}
                />
                <Route
                path="/games/selected-user/:gameId/:playerId/:opponentId/:opponentName/:lobbyId/:lobbyCode/:gameName"
                element={<SelectedUserPage />}
                />

                {/* Legacy route format without opponentName - redirects to appropriate game */}
          <Route
            path="/games/selected-user/:gameId/:playerId/:opponentId/:lobbyId/:lobbyCode/:gameName"
            element={<SelectedUserPage />}
          />

          {/* Game Result Route */}
          <Route path="/game-result" element={<GameResult />} />

          <Route
            path="/game-result"
            element={
              <ProtectedRoute
                element={(props) => (
                  <GameResult {...props} onClose={() => navigate("/")} />
                )}
                navigateTo={navigateTo}
              />
            }
          />
          <Route path="/games/rating" element={<GameRating />} />
          {/* //celebrity */}

          <Route
            path="/celebrity/host/:gameId"
            element={<ProtectedRoute element={HostGame} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/game/:gameId/create"
            element={<ProtectedRoute element={CreateHostedGame} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/game/:winners/:gameId/:tournamentId/winnings"
            element={<ProtectedRoute element={SetWinnings} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/game/tournament/:gameId/fee"
            element={<ProtectedRoute element={GateFee} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/game/tournament/:gameId/code"
            element={<ProtectedRoute element={TournamentCode} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/celebrity/tournaments"
            element={<ProtectedRoute element={MyTournaments} />}
            navigateTo={navigateTo}
          />

          <Route
            path="/celebrity/:tournamentId/leaderboard"
            element={
              <ProtectedRoute element={Leaderboard} navigateTo={navigateTo} />
            }
          />

          <Route
            path="/tournament/lobby/:lobbyCode/:tournamentId/:gameId/:gameName"
            element={
              <ProtectedRoute
                element={TournamentLobby}
                navigateTo={navigateTo}
                key={location.key}
              />
            }
          />

          <Route
            path="/tournament/room/:lobbyCode/:tournamentId"
            element={
              <ProtectedRoute element={WaitingRoom} navigateTo={navigateTo} />
            }
          />
        </Routes>
      </ScrollTo>
    </>
  );
}
